import { useEffect } from 'react';
import { CATALOGO } from '@/constants/catalogo';
import { fmt } from '@/lib/utils';

export default function CfgRenders({ producto, onUpdate }) {
  const catalogo = CATALOGO.rendersHyper;
  const cfg = producto.config || {
    adaptacion: true,
    texturizado: true,
    exteriores: 3,
    interiores: 2,
  };

  const recalc = (newCfg) => {
    let precio = 0;
    if (newCfg.adaptacion) precio += catalogo.base.adaptacion.precio;
    if (newCfg.texturizado) precio += catalogo.base.texturizado.precio;
    precio += (newCfg.exteriores || 0) * catalogo.porUnidad.exterior.precio;
    precio += (newCfg.interiores || 0) * catalogo.porUnidad.interior.precio;
    onUpdate({ config: newCfg, precioFinal: precio });
  };

  useEffect(() => {
    if (!producto.configurado) recalc(cfg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-3">
      <label className="flex items-center justify-between p-3 bg-neutral-900/50 border border-neutral-800 rounded cursor-pointer">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={cfg.adaptacion}
            onChange={(e) => recalc({ ...cfg, adaptacion: e.target.checked })}
            className="accent-brand-gold"
          />
          <span className="text-white text-sm">{catalogo.base.adaptacion.label}</span>
        </div>
        <span className="text-brand-gold text-sm">{fmt(catalogo.base.adaptacion.precio)}</span>
      </label>
      <label className="flex items-center justify-between p-3 bg-neutral-900/50 border border-neutral-800 rounded cursor-pointer">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={cfg.texturizado}
            onChange={(e) => recalc({ ...cfg, texturizado: e.target.checked })}
            className="accent-brand-gold"
          />
          <span className="text-white text-sm">{catalogo.base.texturizado.label}</span>
        </div>
        <span className="text-brand-gold text-sm">{fmt(catalogo.base.texturizado.precio)}</span>
      </label>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs text-neutral-400 uppercase tracking-wider mb-2 block">
            Renders exteriores ({fmt(catalogo.porUnidad.exterior.precio)}/u)
          </label>
          <input
            type="number"
            min="0"
            value={cfg.exteriores}
            onChange={(e) =>
              recalc({ ...cfg, exteriores: parseInt(e.target.value, 10) || 0 })
            }
            className="w-full px-3 py-2 bg-neutral-900 border border-neutral-800 rounded text-white text-sm focus:outline-none focus:border-brand-gold/50"
          />
        </div>
        <div>
          <label className="text-xs text-neutral-400 uppercase tracking-wider mb-2 block">
            Renders interiores ({fmt(catalogo.porUnidad.interior.precio)}/u)
          </label>
          <input
            type="number"
            min="0"
            value={cfg.interiores}
            onChange={(e) =>
              recalc({ ...cfg, interiores: parseInt(e.target.value, 10) || 0 })
            }
            className="w-full px-3 py-2 bg-neutral-900 border border-neutral-800 rounded text-white text-sm focus:outline-none focus:border-brand-gold/50"
          />
        </div>
      </div>
    </div>
  );
}
